<template>
  <div style="width: 100%; height: 100%;" id="divPDF">
    {{pdfContent}}
  </div>
</template>
<script>

  export default {
    name: 'Pdf',
    props: ['url'],
    data() {
      return {
        isShow: false,
        pdfContent: 'בחר קובץ מהתפריט',
      }
    },
    created() {
      this.$Log("Vue [Pdf] is created ...");
    },
    ready() {
      this.$Log("Vue [Pdf] is ready ...");
    },
    mounted() {
      this.$Log("Vue [Pdf] is mounted ...");
      //PDFObject.embed(this.url, "#divPDF");
    },
    updated() {
      this.$Log("Vue [Pdf] is updated ...");
    },
    watch: {
      url(val) {
        if (PDFObject.supportsPDFs) {
          PDFObject.embed(this.url, "#divPDF");
        }
        else {
          this.pdfContent = "PDF not supported";
        }
      }
    },
    computed: {
    },
    methods: {
    }
  }

</script>
<style>
  
</style>



// WEBPACK FOOTER //
// PDF.vue?be51645e